import React from 'react';
interface BillApprovalProps {
  preparedBy: string;
  checkedBy?: string;
  approvedBy?: string;
}
export function BillApproval({
  preparedBy,
  checkedBy,
  approvedBy
}: BillApprovalProps) {
  return <div className="mb-6" data-id="element-11">
      <div className="grid grid-cols-3 gap-6" data-id="element-12">
        {/* Prepared By */}
        <div data-id="element-13">
          <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-14">
            Prepared by:
          </p>
          <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-15">
            <span className="text-xs text-neutral-900" data-id="element-16">{preparedBy}</span>
          </div>
          <p className="text-xs text-neutral-500" data-id="element-17">Signature</p>
        </div>

        {/* Checked By */}
        <div data-id="element-18">
          <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-19">
            Checked by:
          </p>
          <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-20">
            {checkedBy && <span className="text-xs text-neutral-900" data-id="element-21">{checkedBy}</span>}
          </div>
          <p className="text-xs text-neutral-500" data-id="element-22">Signature</p>
        </div>

        {/* Approved By */}
        <div data-id="element-23">
          <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-24">
            Approved by:
          </p>
          <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-25">
            {approvedBy && <span className="text-xs text-neutral-900" data-id="element-26">{approvedBy}</span>}
          </div>
          <p className="text-xs text-neutral-500" data-id="element-27">Signature</p>
        </div>
      </div>
    </div>;
}